import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { SOFTLEAD_LABEL } from '@/constants'

import _validators from '@/utils/validators'

export const useCnpjSearch = () => {
  const {
    control,
    reset,
    handleSubmit,
    formState: { isValid, isSubmitting }
  } = useForm({
    mode: 'onChange'
  })

  useEffect(() => {
    const parsedSoftleadData =
      JSON.parse(sessionStorage.getItem(SOFTLEAD_LABEL)) || {}

    reset(parsedSoftleadData)
  }, [])

  const onBlurField = ({ name, value }) => {
    if (_validators[name](value)) {
      const softleadData = sessionStorage.getItem(SOFTLEAD_LABEL)
      const parsedSoftleadData = JSON.parse(softleadData) || {}

      const newSoftleadData = { ...parsedSoftleadData, [name]: value }

      sessionStorage.setItem(SOFTLEAD_LABEL, JSON.stringify(newSoftleadData))
    }
  }

  return {
    control,
    isValid,
    isSubmitting,
    onBlurField,
    handleSubmit
  }
}
